export const parseChartsDataModel = (selectedData, gridItems, gridKey, chartsArray) => {
    // Find the gridItem with the matching gridKey
    const selectedGridItem = gridItems.find(item => item.key === gridKey);
    // If the selected gridItem is found
    if (selectedGridItem) {
      // Check if an object with the same gridKey already exists in the array
      const existingObjectIndex = chartsArray.findIndex(obj => obj.key === gridKey);
  
      // Create a new object representing the schema
      const newObject = {
        key: selectedGridItem.key,
        x: selectedGridItem.x,
        y: selectedGridItem.y,
        w: selectedGridItem.w,
        h: selectedGridItem.h,
        chartType: selectedData.chartType,
        dimensionType: selectedData.dimensionType,
        machines: selectedData.machines,
        property: selectedData.property
      };
  
      // If an object with the same gridKey already exists, update it
      if (existingObjectIndex !== -1) {
        chartsArray[existingObjectIndex] = newObject;
      } else {
        // Otherwise, append the new object to the array
        chartsArray.push(newObject);
      }
  
      // Return the updated array
      return [...chartsArray];
    } else {
      // If the selected gridItem is not found, return the original array
      return chartsArray;
    }
  };
  